import AnimationMnager from '../module/animation';
import effectManager from '../module/effect';
import Util from '../module/libs/util';
import GoogleMapManager from '../module/libs/googlemap';
import bgManager from './bg';

const animation = new AnimationMnager();
const effect=new effectManager();
const util = new Util();

export default class topManager {
    constructor() {

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.splashFlg = false;

        this.bg = new bgManager();

        /* KVのアニメーション */
        this.$root =  $("#l-root,#l-scroll");
        this.$kv =  $("#p-kv");

        this.slide = {
            $container : this.$kv.find(".p-photo-img"),
            $target : this.$kv.find(".p-img"),
            $cover    :  this.$kv.find(".p-photo-img-cover >*"),
            status : {
                current : 0,
                stop : false, /* ループを停止させる */
                time : 0
            },
            config : {
                pause : 240,
                max : 3,
            }
        }



        this.$link =  this.$kv.find(".stage.js__type-link >a");

        this.flg = false; /* スクロール移動の際にhover表示しているものをoutしたか */

        effect.splitText(this.$kv.find(".js__split-text"),"set");
        // effect.bg(this.slide.$cover,"set");
        effect.bg(this.slide.$target.find(">* >*"),"set");

        /* KVのアニメーション END */

        this.map = new GoogleMapManager();
        /* 低スペック端末用の分岐 */
        this.type = Useragnt.ie||Useragnt.tablet ? "low" : "normal";


    }
    init(display,executionType){

        let _this = this;

        if(executionType==="pjax"){
            _this.splashFlg = true;
        }

        if(_this.splashFlg){

                $("#p-kv-splash-cover").css({'display':'block'});
                TweenMax.staggerTo($("#p-kv-illust .p-suitcase >*"),1.2,
                    {
                        x:0,
                        y:1+"%",
                        ease: "Power2.easeInOut",
                    },0.1);
                TweenMax.set($("#p-kv-illust .p-suitcase svg .st0"),{ stroke : "#03092d" });
                $("#p-kv-splash-cover").addClass("is-start");
                effect.bg($("#p-kv-splash-cover >*"),"out");
                $("#p-kv-content-maincopy").removeClass("is-splash");
                setTimeout(()=>effect.splitText($(".js__split-text >* >*"),"show"),3e2);
                setTimeout(()=>{
                    if(_this.type!=="low") _this.bg.start(display)
                },5e3);

        }else{

            /* 初回動作 */
            let _comp = function () {
                setTimeout(()=>effect.splitText($(".js__split-text.is-splash >* >*"),"show"),5e2);
                setTimeout(function () {
                    TweenMax.staggerTo($("#p-kv-illust .p-suitcase >*"),1.2,
                        {
                            x:0,
                            y:1+"%",
                            ease: "Power2.easeInOut",
                            // ease: "Expo.easeInOut",
                        },0.1);
                    setTimeout(function () {
                        $("#p-kv-splash-cover").addClass("is-start")
                        effect.bg($("#p-kv-splash-cover >*"),"out");
                        _this.splashFlg = true;
                        if(_this.type!=="low") _this.bg.start(display);
                        TweenMax.to($("#p-kv-illust .p-suitcase svg .st0"),0.5,{
                            stroke : "#03092d"
                        });
                    },1e3);
                    setTimeout(function () {
                        $("#p-kv-content-maincopy").removeClass("is-splash");
                        effect.splitText($(".js__split-text.is-splash2 >* >*"),"show");
                    },16e2);
                },2e3);
            }

            for(let i=0; i<$("#p-kv-illust .p-suitcase >*").length; i++){

                let _x = (i%2===0)?1:-1;
                let _y = (i%2===0)?-1:1;

                TweenMax.set($("#p-kv-illust .p-suitcase >*").eq(i).children(),{ x:600*_x,y:600*_y,z:10,opacity:0 });
            }


            TweenMax.staggerTo($("#p-kv-illust .p-suitcase >* >*"),0.8,
                {
                    x:0,
                    y:0,
                    z:0,
                    ease: "Power2.easeOut",
                    // ease: "Expo.easeInOut",
                },0.1,_comp);
            TweenMax.staggerTo($("#p-kv-illust .p-suitcase >* >*"),0.3, {
                opacity:1,
                delay:0.3,
                // scale:1,
                ease: "Power2.easeIn",
            },0.1);

        }

        // effect.bg(_this.slide.$cover,"out");
        this.slideMotion();

        /* テキストエリアの高さをセット */

        /* map読み込み */
        setTimeout(()=>this.map.init(),3e3)

    }
    slideMotion(){
        let _this = this;
        effect.bg(_this.slide.$cover,"show");

        setTimeout(function () {
            _this.slide.$target.filter(".no"+_this.slide.status.current).removeClass("is-current");
            effect.bg(_this.slide.$target.filter(".no"+_this.slide.status.current).find(">* >*"),"out");
        },12e2);

        setTimeout(function () {
            _this.slide.status.current = (_this.slide.status.current<_this.slide.config.max)?_this.slide.status.current+1:1;
            _this.slide.$target.filter(".no"+_this.slide.status.current).addClass("is-current");
            effect.bg(_this.slide.$target.filter(".no"+_this.slide.status.current).find(">* >*"),"show");
        },15e2);

    }
    render(mouse,scrollInc){
        if(this.slide.status.stop) return;
        this.slide.status.time = (this.slide.status.time<this.slide.config.pause)?this.slide.status.time+1:0;
        if(this.slide.status.time==this.slide.config.pause) this.slideMotion();
    }
    resize(){

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        if(Useragnt.tablet) TweenMax.set(this.$root,{height:this.h})
        // TweenMax.set(this.$kv,{width:this.w})
    }
}